import * as React from "react";
import type { SVGProps } from "react";
export const SvgThetaAi = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 33 33" {...props}>
    <path
      fill="currentColor"
      d="m28.07 11.192-.37.849a.76.76 0 0 1-1.4 0l-.37-.849a6.544 6.544 0 0 0-3.328-3.376l-1.14-.507c-.616-.274-.616-1.17 0-1.445l1.076-.478a6.549 6.549 0 0 0 3.376-3.49l.38-.917a.76.76 0 0 1 1.412 0l.38.917a6.55 6.55 0 0 0 3.376 3.49l1.076.478c.616.274.616 1.17 0 1.445l-1.14.507a6.544 6.544 0 0 0-3.328 3.376ZM12 3.5h6v3h-6a9 9 0 0 0-9 9c0 5.415 3.693 8.948 12 12.72V24.5h3a9 9 0 0 0 9-9h3c0 6.628-5.372 12-12 12v5.25c-7.5-3-18-7.5-18-17.25 0-6.627 5.373-12 12-12Z"
    />
  </svg>
);
